export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/manara.c38f432d.svg","height":10,"width":80,"blurWidth":0,"blurHeight":0};